export enum DetailPageType {
    DETAIL_ONLINE = 'DETAIL_ONLINE',
    DETAIL_EXPIRED = 'DETAIL_EXPIRED',
    DETAIL_PARTNER = 'DETAIL_PARTNER',
}

export enum ReachabilityType {
    ANONYMOUS = 'ANONYMOUS',
    PUBLIC = 'PUBLIC',
}

export enum EstateType {
    APARTMENT = 'APARTMENT',
    GARAGE = 'GARAGE',
    HALL = 'HALL',
    HOUSE = 'HOUSE',
    OFFICE = 'OFFICE',
    PROPERTY = 'PROPERTY',
    RETAIL_TRADE = 'RETAILTRADE',
    HOSPITALITY = 'HOSPITALITY',
    AGRONOMY_SIDE = 'AGRONOMYSIDE',
}

export enum OverviewLabel {
    COSTS = 'Kosten & Preise',
    ENERGIES = 'Energie & Versorgung',
    OBJECT_INFO = 'Details',
}

export enum MailModalLabel {
    STICKY = 'modal_sticky',
    DETAIL = 'modal_detail',
}

export enum CarouselLabel {
    FLOORPLAN = 'grundriss_slider',
    GALERIE = 'galerie_slider',
}

export enum KeyInfoLabel {
    GROUND_RENT_PER_YEAR = 'Erbpacht pro Jahr',
    FIXED_RENT = 'Pauschalmiete',
    SELL = 'Kaufpreis',
    LEASE_PER_MONTH = 'Pacht pro Monat',
    PRICE_PER_SQM = 'Preis pro m²',
    RENT = 'Miete',
    RENT_COLD = 'Kaltmiete',
    ROOMS = 'Zimmer',
    AREA = 'Fläche',
    LIVING_AREA = 'Wohnfläche',
    GROUND_AREA = 'Grundstücksfläche',
    SALES_AREA = 'Verkaufsfläche',
    TOTAL_AREA = 'Gesamtfläche',
}

export enum ContactDetail {
    TITLE_NON_COMMERCIAL = 'Private:r Anbieter:in',
    ANONYMOUS_NAME = 'Privat von Eigentümer:in',
}
